var scrollAreaRoot = 'scrollArea_scrollAreaRoot__8ytjsl0';
var scrollbarMarginTop = 'var(--scrollbar-margin-top__8ytjsl1)';

export { scrollAreaRoot, scrollbarMarginTop };
//# sourceMappingURL=scrollArea.vanilla.mjs.map
